import { SalesOrderSortListField } from "@saleor/createOrder/urls";
import orderBy from "lodash/orderBy";

export const sorting = (sortList, sort, secondarySortKeys) => {
  const primarySortKey = sort.sort;

  const orderByForList = sort.asc ? "asc" : "desc";
  const orderByAscending = "asc";
  const orderedList = orderBy(
    sortList,
    [
      item =>
        (primarySortKey === "poNo" ||
          primarySortKey === SalesOrderSortListField.poNo) &&
        typeof item?.poNo === "string"
          ? item?.poNo?.toLowerCase()
          : item[primarySortKey],
      ...secondarySortKeys
    ],
    [orderByForList, orderByAscending, orderByAscending]
  );
  return orderedList;
};

export const sortAndMerge = (list, sort, secondarySortKeys) => {
  const parentSortList = sorting(
    list.filter(item => item?.parentItemNo === ""),
    sort,
    secondarySortKeys
  );
  const childSortList = sorting(
    list.filter(item => item?.parentItemNo !== ""),
    sort,
    secondarySortKeys
  );

  let sortedList = [];
  let index = 0;
  for (index; index < parentSortList.length; index++) {
    if (sort.asc) {
      sortedList.push(parentSortList[index]);
    }
    if (parentSortList[index]?.bomFlag === true) {
      const bomChildFilterlist = childSortList.filter(
        item =>
          +item?.parentItemNo === +parentSortList[index]?.itemNo &&
          (+item?.soNo === +parentSortList[index]?.soNo ||
            +item?.orderNo === +parentSortList[index]?.orderNo)
      );
      sortedList = sortedList.concat(bomChildFilterlist);
    }
    if (!sort.asc) {
      sortedList.push(parentSortList[index]);
    }
  }
  return sortedList;
};
